import {AnswerStatus, ActionStatus} from '@domain/pom'
import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {QueryKeyName, updateAction} from '../../common/backend'
import {allRelatedActionsDoneForQuestionOfAction} from '../../common/backend/actions'
import {FEATURE_NAMESPACE} from '../../consts'
import {ActionItem} from '../../types'
import {usePlantUpmId} from '../usePlantUpmIdContext'

export type EditActionResponse = {
  item: ActionItem
  showMoveQuestToDone?: boolean
}

export type EditActionData = {
  actionItem: ActionItem
  questionAnswer?: AnswerStatus
}

export const useEditAction = (onSuccess?: (data: EditActionResponse) => void) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const plantId = usePlantUpmId()
  const client = useQueryClient()

  return useMutation({
    mutationFn: async ({actionItem, questionAnswer}: EditActionData) => {
      await updateAction({plantId, actionItem})
      const response: EditActionResponse = {item: actionItem}
      if (actionItem.status === ActionStatus.Done && questionAnswer === AnswerStatus.Negative) {
        response.showMoveQuestToDone = await allRelatedActionsDoneForQuestionOfAction(actionItem)
      }
      return response
    },
    onSuccess: (data: EditActionResponse) => {
      void client.invalidateQueries({queryKey: [QueryKeyName.GetActionItems]})
      spawnSuccessToast(t('editAction.afterSubmit.success'))
      onSuccess?.(data)
    },
    onError: () => {
      spawnErrorToast(t('editAction.afterSubmit.error'))
    }
  })
}
